/**
 * @author Kelnik
 *
 * History - класс для работы с get параметрами
 */

class History {
    /**
     * Добавляет (обновляет) гет параметр по названию параметра
     * Если param массив, то идет добавление если нет повторов в value
     * Что бы param был массивом предать в param в виде "name[]"
     * @param {string} param - название параметра
     * @param {string} value - значение параметра
     */
    static append(param, value) {
        const get = window.location.search;
        const url = new URLSearchParams(get);

        if (!get) {
            url.append(param, value);
        } else if (url.get(param)) {
            if (param.substr(-2) === '[]') {
                const allValues = url.getAll(param);

                if (allValues.indexOf(value) === -1) {
                    url.append(param, value);
                }
            } else {
                url.set(param, value);
            }
        } else {
            url.append(param, value);
        }

        history.pushState(null, null, `?${url.toString()}`);
    }

    static setUrl(url) {
        history.pushState(null, null, `${url}`);
    }

    static createUriFromObj(filter) {
        let str = '';

        // eslint-disable-next-line guard-for-in
        for (const key in filter) {
            if (str !== '') {
                str = `${str}&`;
            }
            if (Array.isArray(filter[key])) {
                for (let i = 0; i < filter[key].length; i++) {
                    str = `${str}${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(filter[key][i])}`;
                    if (filter[key].length - 1 !== i) {
                        str = `${str}&`;
                    }
                }
            } else {
                str = `${str}${encodeURIComponent(key)}=${encodeURIComponent(filter[key])}`;
            }
        }

        return str;
    }

    /**
     * Форм дата переводит в url
     * Если несколько идентичных param то переводятся в масив ("param[]")
     * Перед добавлением отчищается все переданные параметны
     * @param {FormData} formData - название параметра
     */
    // eslint-disable-next-line max-statements
    static appendFromFormData(formData) {
        const get = window.location.search;
        const url = new URLSearchParams(get);

        if (!formData) {
            return;
        }

        const prettyFormData = new FormData();

        for (const pair of formData) {
            const param = pair[0];
            const value = pair[1];

            if (prettyFormData.get(`${param}[]`)) {
                prettyFormData.append(`${param}[]`, value);
            } else if (prettyFormData.get(param) && param.substr(-2) !== '[]') {
                const oldValue = prettyFormData.get(param);

                prettyFormData['delete'](param);
                prettyFormData.append(`${param}[]`, oldValue);
                prettyFormData.append(`${param}[]`, value);
            } else {
                prettyFormData.append(param, value);
            }
        }

        for (const pair of prettyFormData) {
            url['delete'](pair[0]);
        }

        for (const pair of prettyFormData) {
            const param = pair[0];
            const value = pair[1];

            if (!get) {
                url.append(param, value);
            } else if (url.get(param)) {
                if (param.substr(-2) === '[]') {
                    const allValues = url.getAll(param);

                    if (allValues.indexOf(value) === -1) {
                        url.append(param, value);
                    }
                } else {
                    url.set(param, value);
                }
            } else {
                url.append(param, value);
            }
        }

        history.pushState(null, null, `?${url.toString()}`);
    }

    /**
     * Вставляет строку в гет параметры
     * @param {String} search - Строка гет запроса
     */
    static setFromString(search) {
        const prettySearch = search.substr(0, 1) === '?' ? search : `?${search}`;

        history.pushState(null, null, prettySearch);
    }

    /**
     * Заменяет строку в гет параметры
     * @param {String} search - Строка гет запроса
     */
    static replaceFromString(search) {
        let prettySearch = search.substr(0, 1) === '?' ? search : `?${search}`;

        if (prettySearch === '?') {
            prettySearch = '';
        }
        history.replaceState(null, null, prettySearch);
    }

    /**
     * Удаляет гет параметр по названию параметра (и по значениею)
     * Если param не найден удаляется param[] (массив)
     * @param {string} param - название параметра
     * @param {string} value - значение параметра (если удаляем из масива) (необязательно)
     */
    static remove(param, value = '') {
        const get = window.location.search;
        const url = new URLSearchParams(get);
        let paramName = param;

        if (!get) {
            return;
        }

        if (paramName.substr(-2) === '[]') {
            paramName = paramName.slice(0, -2);
        }

        if (value) {
            const allParams = url.getAll(`${paramName}[]`);

            url['delete'](`${paramName}[]`);

            allParams.forEach((itemParam) => {
                if (itemParam !== value) {
                    url.append(`${paramName}[]`, itemParam);
                }
            });
        } else if (url.get(paramName)) {
            url['delete'](paramName);
        } else if (url.get(`${paramName}[]`)) {
            url['delete'](`${paramName}[]`);
        }

        history.pushState(null, null, `?${url.toString()}`);
    }

    // eslint-disable-next-line valid-jsdoc
    /**
     * Удаляет все гет параметры
     */
    static clear(char = '?') {
        history.pushState(null, null, char);
    }

    /**
     * Возращает значение гет параметра по названию параметра
     * @param {string} param - название параметра
     * @return {string} - значение get param'етра
     */
    static get(param) {
        const get = window.location.search;
        const url = new URLSearchParams(get);
        let paramName = param;

        if (paramName.substr(-2) === '[]') {
            paramName = paramName.slice(0, -2);
        }

        return url.get(paramName) || url.getAll(`${paramName}[]`);
    }

    /**
     * Возращает гет параметны в стоковом формате
     * @return {String} - гет параметны
     */
    static getString() {
        return window.location.search;
    }

    /**
     * Возращает гет параметны в объекте
     * @return {Object} - объект гет параметров
     */
    static getObject() {
        const get = window.location.search;
        const url = new URLSearchParams(get);
        const result = {};

        for (const pair of url) {
            let key = pair[0];

            if (key.substr(-2) === '[]') {
                key = key.slice(0, -2);
            }

            if (Object.prototype.hasOwnProperty.call(result, key)) {
                if (typeof result[key] === 'string' || result[key] instanceof String) {
                    result[key] = [result[key], pair[1]];
                } else {
                    result[key].push(pair[1]);
                }
            } else {
                result[key] = pair[1];
            }
        }

        return result;
    }

    /**
     * Возращает гет параметны в формате FormData
     * @return {FormData} - FormData гет параметров
     */
    static getFormData() {
        const get = window.location.search;
        const url = new URLSearchParams(get);
        const result = new FormData();

        for (const pair of url) {
            result.append(pair[0], pair[1]);
        }

        return result;
    }

    /**
     * Возращает существует ли такой гет параметр
     * Проверяет существование по имени и по значениею
     * @param {String} name - название параметра
     * @param {String} value - значение параметра
     * @return {Boolean} - результат
     */
    static has(name, value = '') {
        const get = window.location.search;
        const url = new URLSearchParams(get);

        if (value) {
            let values = [];

            if (url.getAll(name).length) {
                values = url.getAll(name);
            } else if (url.getAll(`${name}[]`).length) {
                values = url.getAll(`${name}[]`);
            }

            const lowerValues = values.map((v) => {
                return v.toLocaleLowerCase();
            });

            return lowerValues.indexOf(value.toLocaleLowerCase()) !== -1;
        }

        return url.has(name) || url.has(`${name}[]`);
    }
}

export default History;
